const RootPath = window.g.baseUrl
const apis = {
  /* 角色 api */
  getRoles: RootPath + 'plugin/authority/role/index',
  getRole: RootPath + 'plugin/authority/role/getForm',
  saveRole: RootPath + 'plugin/authority/role/save',
  delRoles: RootPath + 'plugin/authority/role/delBatches',
  getAllButtons: RootPath + 'plugin/authority/role/getAllButtons',

  /* 用户 */
  getUsers: RootPath + 'plugin/authority/user/index',
  getUser: RootPath + 'plugin/authority/user/getForm',
  saveUser: RootPath + 'plugin/authority/user/save',
  delUsers: RootPath + 'plugin/authority/user/delBatches',
  savePsw: RootPath + 'plugin/authority/user/savePsw',
  initPsw: RootPath + 'plugin/authority/user/initPsw',

  /* 菜单 */
  // 获取菜单列表
  getMenus: RootPath + 'plugin/authority/menu/index',
  // 获取单个菜单
  getMenu: RootPath + 'plugin/authority/menu/getForm',
  // 保存
  saveMenu: RootPath + 'plugin/authority/menu/save',
  // 删除
  delMenus: RootPath + 'plugin/authority/menu/delBatches'
}

export default apis
